import React from 'react';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { PrintReceivedPalletAndCaseLabels } from './printReceivedPalletAndCaseTags';

const PrintConsumedPalletAndCaseLabelsModal = ({ poMapId, type, onClose, open }) => {
    return (
        <div>
            <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="lg">
                <DialogTitle style={{ textAlign: 'center', paddingBottom: 0 }}>
                    Print Pallet And Case Labels for Consumed Lots That Have No Units in Jalapeno.
                </DialogTitle>
                <DialogContent style={{ margin: 0 }}>
                    <PrintReceivedPalletAndCaseLabels type={type} poMapId={poMapId} includeEmptyCases={true} />
                </DialogContent>
            </Dialog>
        </div>
    );
};

export { PrintConsumedPalletAndCaseLabelsModal };
